<template>
      <!-- ============================ Sidebar Start ============================ -->
       <nav :class="['sidebar', 'sidebar-offcanvas', { 'open': isOpen }]" id="sidebar">
        <div class="sidebar-header">
          <router-link to="/super-admin" class="sidebar-brand">
            <img src="/images/logo.png" alt="Strata Yourself" class="sidebar-logo-full" />
            <img src="/images/favicon.png" alt="Strata Yourself" class="sidebar-logo-mini" />
          </router-link>
          <button
            class="sidebar-collapse-btn d-none d-lg-flex"
            :class="{ 'is-collapsed': isCollapsed }"
            type="button"
            :aria-label="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
            @click="$emit('toggleCollapse')"
          >
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <button
            class="sidebar-close-btn d-lg-none"
            type="button"
            aria-label="Close sidebar"
            @click="$emit('close')"
          >
            <i class="mdi mdi-close"></i>
          </button>
        </div>
        <ul class="nav">
          <li class="nav-item" :class="{'active': $route.path === '/super-admin'}">
            <RouterLink class="nav-link" to="/super-admin">
              <i class="mdi mdi-view-dashboard menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </RouterLink>
          </li>
          <li class="nav-item nav-category">Pages</li>
          <li class="nav-item" :class="{'active': $route.path === '/users' || $route.path === '/view-dashboard'}">
            <RouterLink class="nav-link" to="/users">
              <i class="menu-icon mdi mdi-account-group"></i>
              <span class="menu-title">Users</span>
            </RouterLink>
          </li>
          <li class="nav-item" :class="{'active': $route.path === '/subscriptions'}">
            <RouterLink class="nav-link" to="/subscriptions">
              <i class="menu-icon mdi mdi-playlist-check"></i>
              <span class="menu-title">Subscriptions</span>
            </RouterLink>
          </li>
          <li class="nav-item" :class="{'active': $route.path === '/trial-settings'}">
            <RouterLink class="nav-link" to="/trial-settings">
              <i class="menu-icon mdi mdi-timer-sand"></i>
              <span class="menu-title">Trial Settings</span>
            </RouterLink>
          </li>
          <!-- <li class="nav-item" :class="{'active': $route.path === '/products'}">
            <RouterLink class="nav-link" to="/products">
              <i class="menu-icon mdi mdi-package-variant-closed"></i>
              <span class="menu-title">Products</span>
            </RouterLink>
          </li> -->
          <!-- <li class="nav-item" :class="{'active': $route.path === '/bot'}">
            <RouterLink class="nav-link" to="/bot">
              <i class="menu-icon mdi mdi-google-cardboard"></i>
              <span class="menu-title">Train Bot</span>
            </RouterLink>
          </li> -->
          <li class="nav-item" :class="{'active': $route.path === '/transactions'}">
            <RouterLink class="nav-link" to="/transactions">
              <i class="menu-icon mdi mdi-cash-fast"></i>
              <span class="menu-title">Transactions</span>
            </RouterLink>
          </li>
          <li class="nav-item" :class="{'active': $route.path === '/users-token'}">
            <RouterLink class="nav-link" to="/users-token">
              <i class="menu-icon mdi mdi-poker-chip"></i>
              <span class="menu-title">Users Token</span>
            </RouterLink>
          </li>
          <li class="nav-item" :class="{'active': $route.path === '/stripe-settings'}">
            <RouterLink class="nav-link" to="/stripe-settings">
              <i class="menu-icon mdi mdi-credit-card-settings"></i>
              <span class="menu-title">Stripe Settings</span>
            </RouterLink>
          </li>
        </ul>
      </nav>
      <!-- ============================ Sidebar End  ============================ -->
</template>

<script>
  import { mapState } from "vuex";
export default {
  name: "SidebarPage",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'toggleCollapse'],
  components: {
  },

  computed: {
        ...mapState({
          user: (state) => state.auth.user,
        }),
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar-header {
  height: 97px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
}
.sidebar-brand {
  display: flex;
  align-items: center;
  min-width: 0;
}
.sidebar-logo-full {
  height: 56px;
  width: auto;
  max-width: 100%;
}
.sidebar-logo-mini {
  display: none;
  height: 40px;
  width: auto;
}
.sidebar-collapse-btn,
.sidebar-close-btn {
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #484848;
  flex-shrink: 0;
  transition: background 0.2s ease, transform 0.25s ease;
}
.sidebar-collapse-btn:hover,
.sidebar-close-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}
.sidebar-collapse-btn i {
  transition: transform 0.25s ease;
}
.sidebar-collapse-btn.is-collapsed i {
  transform: rotate(180deg);
}

@media (min-width: 992px) {
  .sidebar-icon-only .sidebar-header {
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    padding: 10px 8px;
  }
  .sidebar-icon-only .sidebar-logo-full {
    display: none;
  }
  .sidebar-icon-only .sidebar-logo-mini {
    display: block;
    margin: 0 auto;
  }
  .sidebar-icon-only .sidebar-collapse-btn {
    width: 24px;
    height: 24px;
  }
  /* .sidebar-offcanvas's own width: 260px (below) ties in specificity
     with the template's collapsed-state ".sidebar-icon-only .sidebar
     { width: 70px }" rule and was winning on load order, so the
     sidebar never actually shrank to its icon-only rail - it stayed
     260px wide while the content area's margin collapsed to 70px,
     leaving the sidebar overlapping the page content. */
  .super-admin-shell.sidebar-icon-only .sidebar-offcanvas {
    width: 70px;
  }
  /* The template has its own icon-only active-icon color rule
     (.sidebar-icon-only .sidebar .nav .nav-item.active .nav-link
     i.menu-icon { color: #1F3BB3 }) that's more specific than the
     white override below, so the active icon reverted to the old
     blue whenever the sidebar was collapsed. */
  .super-admin-shell.sidebar-icon-only .sidebar .nav .nav-item.active .nav-link i.menu-icon {
    color: #fff;
  }
}

@media (max-width: 991px) {
  /* The template's base off-canvas rule starts the sidebar at
     top: 97px (below the header) with a matching reduced max-height.
     This sidebar carries its own logo/close header instead, so it
     should run the full height of the screen and sit above the fixed
     top navbar (z-index 1030) when open, not tuck in underneath it. */
  .sidebar-offcanvas {
    top: 0;
    max-height: 100vh;
    left: -260px;
  }
  .open {
    left: 0 !important; /* Sidebar slides into view */
    z-index: 1040;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
  }
}

/* Pill-style nav: rounded, inset items with a soft hover tint and a
   solid filled active state, replacing the template's flush-right,
   left-accent-bar look to match the target reference design. */
.sidebar .nav {
  padding-left: 8px;
  padding-right: 8px;
  /* The template default leaves a 60px gap below the last item, which
     was eating into space needed for the items above it to fit
     on-screen without scrolling. */
  margin-bottom: 12px;
}
.sidebar .nav .nav-item {
  margin-bottom: 0;
}
.sidebar .nav .nav-item .nav-link {
  color: #5f6b7a;
  border-radius: 12px;
  transition: background 0.2s ease, color 0.2s ease;
}
.sidebar .nav .nav-item .nav-link i.menu-icon {
  color: #5f6b7a;
}
.sidebar .nav .nav-item.nav-category {
  padding-top: 12px;
  padding-bottom: 4px;
}
/* Tighten only on desktop, where the sidebar has a hard 100vh cap -
   mobile keeps the template's larger touch-target padding (see
   custom.css's "Larger touch targets" rule) since it can scroll. */
@media (min-width: 992px) {
  .sidebar .nav .nav-item .nav-link {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.sidebar .nav .nav-item:hover > .nav-link {
  background: #e3f5f3;
}
.sidebar .nav .nav-item.active > .nav-link {
  background: #0b7b78;
  border-radius: 12px;
}
.sidebar .nav .nav-item.active > .nav-link[aria-expanded="true"],
.sidebar .nav .nav-item.active > .nav-link[aria-expanded="false"],
.sidebar .nav .nav-item.active > .nav-link.collapsed {
  border-radius: 12px;
}
.sidebar .nav .nav-item.active > .nav-link i,
.sidebar .nav .nav-item.active > .nav-link .menu-title,
.sidebar .nav .nav-item.active > .nav-link .menu-arrow {
  color: #fff;
}

.sidebar-offcanvas {
  background: #fff;
  width: 260px;
  scrollbar-width: thin;
  scrollbar-color: rgba(11, 123, 120, 0.25) transparent;
}
.sidebar-offcanvas::-webkit-scrollbar {
  width: 6px;
}
.sidebar-offcanvas::-webkit-scrollbar-thumb {
  background: rgba(11, 123, 120, 0.25);
  border-radius: 3px;
}
</style>
